module.exports = __webpack_public_path__ + "static/media/logoABC.0391daeb.jpg";